import request from '@/utils/server'


export function getFeeList(query) {
    return request({
      url: '/cost/getFeeList',
      method: 'get',
      params: query
    })
  }